import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=09081be5&"
import script from "./apps.vue?vue&type=script&lang=js&"
export * from "./apps.vue?vue&type=script&lang=js&"
import style0 from "./apps.vue?vue&type=style&index=0&id=09081be5&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09081be5')) {
      api.createRecord('09081be5', component.options)
    } else {
      api.reload('09081be5', component.options)
    }
    module.hot.accept("./apps.vue?vue&type=template&id=09081be5&", function () {
      api.rerender('09081be5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/authority/components/apps.vue"
export default component.exports